
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/panduan-konsumen/tanda-tangan-elektronik",
      function () {
        return require("private-next-pages/panduan-konsumen/tanda-tangan-elektronik.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/panduan-konsumen/tanda-tangan-elektronik"])
      });
    }
  